import React, { useContext, useEffect, useMemo, useReducer, useRef, useState } from "react";
import { useAppUserAccess } from "global/cnr/contexts/useHelpers/useAppUserAccess";
import { ParentContext } from '../../../../global/cnr/contexts/ParentContext';
import { _cacheNames, _cacheTypes } from "../../../../global/cnr/reducers/ServiceWorkerReducer";
import { sportsDistrictHandlers, sportsDistrictInitialState, sportsDistrictReducer } from "../reducers/SportsDistrictReducer";
import { _sportsInfoTypes, useSportsInfo } from "projectSpecific/sports/useHelpers/useSportsInfo";
import { _showAppLogs } from "global/cnr/contexts/LogContext";
import { useAppUsers } from "global/cnr/contexts/useHelpers/useAppUsers";

export const SportsDistrictContext = React.createContext()

export default function SportsDistrictProvider(props) {


  const { getCurrentAppUserCounts, getDailyAppUserCount } = useAppUsers()

  const { directReturn } = props ?? {}

  const parentContext = useContext(ParentContext)
  const { states, fns } = parentContext ?? {}
  const { appUser_state, paps_state, page_state, serviceWorker_state, currentSettings_state } = states ?? {}
  const { database_fns } = fns ?? {}

  const { appUser } = appUser_state ?? {}
  const appUserAccess = useAppUserAccess()
  const { isSuperAdmin } = appUserAccess ?? {}
  const { uid } = appUser ?? {}

  const { cache_info } = serviceWorker_state ?? {}
  const { cache_groups } = cache_info ?? {}
  const { cache_district } = cache_groups ?? {}

  // papsContext 
  const { view, pathViews, viewKey } = paps_state ?? {}
  const { districts: districts_key } = pathViews ?? {}

  // pageContext 
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { aps_page } = _.get(page_state, 'pageSettings', {});
  const { sportPermissions } = aps_global ?? {}

  const { viewItems: viewItems_page } = aps_page ?? {}

  let viewItem = viewItems_page && viewItems_page[view] ? viewItems_page[view] : {}
  const { dataSource } = viewItem ?? {}
  const { dataParents, useSeasonals } = dataSource ?? {}

  const _cacheKey = _cacheNames.cache_district + '-' + districts_key
  const _cacheData = cache_district && cache_district[districts_key]

  let ownerPath;

  if (pathViews) {
    if (pathViews.schools) { ownerPath = 'schools' }
    if (pathViews.districts) { ownerPath = 'districts' }
    if (pathViews.organizations) { ownerPath = 'organizations' }
  }

  const init_state = {
    sportPermissions,
    pathViews,
    viewItem,
    dataParents,
    useSeasonals,
    uid,
    ownerPath,
    inverted: false,
    cssOpts: { name: 'ssc-normal' },
    _cacheData,
    database_fns,
  }

  const [sportsDistrict_state, sportsDistrict_dispatch] = useReducer(sportsDistrictReducer, init_state, sportsDistrictInitialState)

  const sportsDistrict_handlers = useMemo(
    () => sportsDistrictHandlers(sportsDistrict_dispatch),
    [sportsDistrict_dispatch]
  );
  const { district_data } = sportsDistrict_state ?? {}

  const [districtInfo, setDistrictInfo] = useState()
  const _loading = useRef(null);

  // _showAppLogs.sportsDistricts && console.log('districtInfo', districts_key, _loading, districtInfo)

  const { getSportInfoData } = useSportsInfo({ pathViews, sportsInfoType: _sportsInfoTypes.districts, existingData: district_data })

  useEffect(() => {
    // if (!districts_key || (_loading.current === districts_key)) return;
    if (!districts_key) return;
    _loading.current = districts_key;
    _showAppLogs.sportsDistricts && console.log('⭐⭐ new district', districts_key)
    getSportInfoData(_sportsInfoTypes.districts, districts_key, setDistrictInfo)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [districts_key])

  useEffect(() => {
    if (_.isEmpty(districtInfo) || !districts_key) return;
    _showAppLogs.sportsDistricts && console.log('🟩 ⭐⭐ districtInfo', districts_key, districtInfo)
    sportsDistrict_handlers.handleSet_districtInfo(districtInfo)
    if (isSuperAdmin) {
      getCurrentAppUserCounts({ pathViews, callback: sportsDistrict_handlers?.handleSet_currentUsers })
      getDailyAppUserCount({ pathViews, callback: sportsDistrict_handlers?.handleSet_dailyUsers })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [districtInfo])

  if (sportsDistrict_state) {
    if (directReturn) {
      return { sportsDistrict_handlers, sportsDistrict_state }
    } else {
      return <SportsDistrictContext.Provider
        value={{ sportsDistrict_state, sportsDistrict_handlers, appComponent: 'sportsDistrict' }}>
        {props.children}
      </SportsDistrictContext.Provider>
    }
  } else {
    return <SportsDistrictContext.Provider
      value={{}}>
      {props.children}
    </SportsDistrictContext.Provider>
  }
}